import { useEffect, useState } from 'react';
import OTPInput from 'otp-input-react';
import { Button } from '@/components/Elements';
import { useAuth } from '@/lib/auth';
import { showNotification } from '@/utils/notificationUtils';
import { Header } from '@/features/availability/components/Header';
import Utils from '@/utils/util';
import { useGenerateOTP } from '../api/generateOtp';
import './VerifyOtp.scss'
type LoginFormProps = {
  onBackClick?: () => void;
  onSuccess?: () => void;
};
export const VerifyOtp = ({ onBackClick, onSuccess }: LoginFormProps) => {
  const { login } = useAuth();
  const generateOtpMutation = useGenerateOTP();
  const [email, setEmial] = useState('');
  const [otp, setOtp] = useState('');
  const emaiId = localStorage.getItem('UsersEmail');

  useEffect(() => {
    if (emaiId) {
      setEmial(emaiId);
    }
  }, [emaiId]);

  const validate = () => {
    if (!email || email.trim().length < 1 || !Utils.isValidEmail(email)) {
      showNotification({
        type: 'info',
        title: 'Please enter valid email',
      });
      return false;
    }
    else if (!otp || otp.trim().length < 6) {
      showNotification({
        type: 'info',
        title: 'Please enter 6 digit code',
      });
      return false;
    }
  
    return true;
  };

  
  return (
    <div className="full-height">
      <div className="top-cotent">
        <Header
          onBackClick={() => {
            if (onBackClick) {
              onBackClick();
            }
          }}
        />
        <div className="page-cotent-title">Verify Email</div>
        <div className="input-out-block verify-blk">
          {`Enter the 6-digit code sent to you at ${emaiId}`}
        </div>
        <div className="input-out-block verify-blk">
          <OTPInput
            value={otp}
            onChange={setOtp}
            autoFocus
            OTPLength={6}
            otpType="number"
            className="otp-input-root"
            inputClassName="otp-input"
            disabled={false}
            secure
          />
          
        </div>
        <div className="already-login text-alignment">
          {generateOtpMutation.isLoading ? (
            <>
              <span>Sending...</span>
            </>
          ) : (
            <a
              className="link"
              onClick={async () => {
           
                  await generateOtpMutation.mutateAsync({
                    email: email,
                  });
              
              }}
            >
             Resend code
            </a>
          )}
        </div>
      </div>
      <div className="footer-btn-container">
        <Button
          type="button"
          variant="primary"
          className="w-full inline-flex justify-center rounded-md border profile-new-btn"
          onClick={async () => {
            if (validate()) {
              await login({
                email,
                otp,
              });
              if (onSuccess) {
                onSuccess();
              }
            }
          }}
        >
          Continue
        </Button>
      </div>
    </div>
  );
};
